export default "__VITE_ASSET__2e92a1d9__"